/* eslint-disable @nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';
import { FeatureToggleFlags, StorageKeys } from '@core/enums';
import { API, environment } from '@core/envs';
import { IFeatureToggle, IResponseModel } from '@core/interface';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleLibService {
  readonly #http = inject(HttpClient);
  flags: { [key in FeatureToggleFlags]?: IFeatureToggle } = {};

  getFlags(country: string): Observable<{ [key in FeatureToggleFlags]?: IFeatureToggle }> {
    this.flags = this.#getFromStorage();
    if (Object.keys(this.flags).length) {
      return of(this.flags);
    }

    // Fetch list if not in session storage
    const api = environment.getRoute(API.backoffice, true);
    const url = `${api}/feature-toggle/v1/${country}`;
    return this.#http.get<IResponseModel<IFeatureToggle[]>>(url).pipe(
      map(data => {
        this.flags = this.mapAndSaveFlags(data.response);

        return this.flags;
      }),
    );
  }

  mapAndSaveFlags(data: IFeatureToggle[]): { [key in FeatureToggleFlags]?: IFeatureToggle } {
    const flags = data.reduce((acc, item) => {
      if (Object.values(FeatureToggleFlags).includes(item.code as FeatureToggleFlags)) {
        acc[item.code as FeatureToggleFlags] = item;
      }
      return acc;
    }, {} as { [key in FeatureToggleFlags]?: IFeatureToggle });
    sessionStorage.setItem(StorageKeys.FEATURE_TOGGLE, JSON.stringify(flags));

    return flags;
  }

  #getFromStorage(): { [key in FeatureToggleFlags]?: IFeatureToggle } {
    return JSON.parse(sessionStorage.getItem(StorageKeys.FEATURE_TOGGLE) ?? '{}') as { [key in FeatureToggleFlags]?: IFeatureToggle };
  }
}
